// src/pages/ConnectGoogleAccount.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAuthHeaders } from "../services/authHeaders";

function ConnectGoogleAccount() {
  const navigate = useNavigate();
  const XANO_BASE_URL = "https://api.sobevenda.com.br/api-proxy/affiliate";

  useEffect(() => {
    axios
      .get(`${XANO_BASE_URL}/google-auth-url`, {
        headers: getAuthHeaders(),
      })
      .then((res) => {
        const url = res.data?.url;
        if (url) {
          window.location.href = url;
        } else {
          throw new Error("URL de autenticação não encontrada.");
        }
      })
      .catch(() => {
        alert("Erro ao conectar com o Google. Tente novamente.");
        navigate("/google-ads");
      });
  }, [navigate]);

  return <div className="p-6">Redirecionando para o Google...</div>;
}

export default ConnectGoogleAccount;
